var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Connecting your accounts...")]),_c('oauth-connect',{attrs:{"callback-payload":this.$route.query}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }